module.exports = __webpack_public_path__ + "static/media/Living-3.d354ce2f.webp";